import { render } from "./desktop_app_overlay.vue?vue&type=template&id=39b3c562&scoped=true"
import script from "./desktop_app_overlay.vue?vue&type=script&lang=js"
export * from "./desktop_app_overlay.vue?vue&type=script&lang=js"

import "./desktop_app_overlay.vue?vue&type=style&index=0&id=39b3c562&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b3c562"]])

export default __exports__